import { useState, useEffect } from "react";
import middleSectionSpotlight from "../../assets/images/fillers/middleSectionSpotlight.jpg";

const MiddleSection = () => {
  const [offsetY, setOffsetY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      requestAnimationFrame(() => {
        setOffsetY(window.scrollY * 0.08);
      });
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="  px-4  md:px-24 flex flex-col md:flex-row items-center gap-16 overflow-hidden">
      <div className="left pt-36 md:pb-28 flex flex-col items-start text-center md:text-left w-full md:w-1/2 gap-16">
        <div className="top text-3xl">
          Empowering Global Knitwear with <span className="highlight">25+ Years of Innovation</span>, <span className="highlight">1000+ Machines</span>, and a Commitment to <span className="highlight">Quality & Care</span>!
        </div>
        <div className="bottom font-merriweather tracking-wider leading-[180%]">
          Bangladesh, renowned for its rich textile heritage, has fostered an industry that blends tradition with innovation. Established in <span className="font-black">1998</span>, Unity Fabric Industries Ltd. has become a leading name in the knitwear industry, serving <span className="font-black">European and US markets</span> with exceptional products. As a <span className="font-black">BGMEA member and Private Limited Company</span>, we set benchmarks in quality, efficiency, and workplace excellence.
        </div>
      </div>
      <div className="right w-full md:w-1/2 h-fit relative overflow-hidden">
      <div className="right w-full h-[500px] md:h-[550px] overflow-hidden rounded-lg px-2">
  <img
    className="shadow-[rgba(0,0,0,0.24)_0px_3px_8px] rounded-xl absolute top-0 left-1/2 w-[95%]"
    src={middleSectionSpotlight}
    alt=""
    style={{
      transform: `translate(-50%, ${offsetY}px)`,
      transition: "transform 0.4s ease-out",
    }}
  />
</div>
</div>
    </div>
  );
};

export default MiddleSection;
